import {Component, Input} from '@angular/core';
import {DomainStatus, DomainStatusLabels} from '../../domain/domain-status.enum';

@Component({
  selector: 'cm-domain-status-circle-plate',
  template: `
    <cm-domain-status-circle [status]="status" [showTooltip]="false"></cm-domain-status-circle>
    <span>
      {{DomainStatusLabels[status]}}
      <span *ngIf="rejectReason&&status===DomainStatus.REJECTED">
        <i class="far fa-info-circle ml-2 text-info" [matTooltip]="rejectReason"></i>
      </span>
      <span *ngIf="test">- test</span>
    </span>
  `
})
export class DomainStatusCirclePlateComponent {

  @Input()
  public status: DomainStatus;
  @Input()
  public test: boolean;

  @Input()
  public rejectReason: string;

  public DomainStatus = DomainStatus;
  public DomainStatusLabels = DomainStatusLabels;

}
